import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import AssetsButton from './AssetButton'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import { selectLatestRatesBidAsk } from '../../../../store/redusers/assets/selectors'


const AssetsButtons = ({assetSoId, clickAsset, customSx, active }) => {
	const latestRatesBidAsk = useSelector(selectLatestRatesBidAsk(assetSoId))
	const { theme } = useDefaultComponentTools(true)
	const bidRate = latestRatesBidAsk.bid
	const askRate = latestRatesBidAsk.ask
	const askUp = latestRatesBidAsk.askUp
	const bidUp = latestRatesBidAsk.bidUp
	const redColor = theme.palette.red
	const greenColor = theme.palette.green
	const defaultColor = theme.palette.text.primary
	const bidColor = bidUp ? greenColor : (bidUp === undefined ? defaultColor : redColor)
	const askColor = askUp ? greenColor : (askUp === undefined ? defaultColor : redColor)

	return (
		<Box  sx={{display: 'flex', gap: '8px', justifyContent: 'space-between', ...customSx}} >
			<AssetsButton clickAsset={clickAsset} rate={bidRate} color={bidColor} action={'sell'} active={active}/>
			<AssetsButton clickAsset={clickAsset} rate={askRate} color={askColor} action={'buy'} active={active}/>
		</Box>
	)
}

AssetsButtons.propTypes = {
	active: PropTypes.string,
	assetSoId: PropTypes.string,
	buttonSx: PropTypes.object,
	clickAsset: PropTypes.func,
	customSx: PropTypes.object
}

AssetsButtons.displayName = 'AssetsButtons'

export default AssetsButtons
